import { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useUserQuery } from 'network/queries';
import { isEffectiveConfigAdmin } from 'utils/user';
import { Loader } from '../../components/Loader';
import { ROUTES } from '../consts';

/**
 * Gate for the git-provider installation wizard routes (GitHub / GitLab /
 * Azure / Bitbucket). Connecting a provider is a config-class admin action, so
 * only an effective config admin may enter a wizard; everyone else is sent back
 * to the Integrations page. Mirrors `PersonasProtectedRoute` (Loader while the
 * user resolves → `<Navigate>` when denied) so a non-admin deep-link or stale
 * bookmark can't mount the wizard. The card-level gating in `GitProviderCard`
 * is the first line; this guard is the defense-in-depth backstop.
 */
export const InstallationWizardProtectedRoute = ({
  children,
}: PropsWithChildren) => {
  const { data: user, isLoading } = useUserQuery();

  if (isLoading) {
    return <Loader center />;
  }

  if (!isEffectiveConfigAdmin(user)) {
    return <Navigate to={ROUTES.INTEGRATIONS} replace />;
  }

  return <>{children}</>;
};
